import React, { useState } from "react";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { FixedBottom } from "./FixedBottom";
import { AddGoodsModal } from "./AddGoodsModal";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { MaterialCodeModal } from './materialModel'
import { useAssetsInventoryDetailsModel } from "./assetsInventoryDetailsModel";

export const InventoryAssetsInventoryDetails = () => {
    const { getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { resetEditCatch,getSDcDetailOne,setMaterialCodeVisible,materialCodeVisible } = useAssetsInventoryDetailsModel()

    return (
        <>
            {detailsInfo && <>
                <FormBox {...detailsInfo} />
                <TableBox {...detailsInfo} />
                <FixedBottom {...detailsInfo} />
                <AddGoodsModal {...detailsInfo} />
                {materialCodeVisible&&<MaterialCodeModal/>}
            </>
            }
        </>
    )
}